import { useMutation } from '@tanstack/react-query';
import { showSuccess, showError } from './toast';
import api from '../Services/api';
import { queryClient } from './queryClient';

export const useDeleteData = (
  queryKeyToInvalidate: any[],
  successMessage = 'Excluído com sucesso!'
) => {
  return useMutation({
    mutationFn: async ({
      endpoint,
      id,
    }: {
      endpoint: string;
      id: string | number;
    }) => {
      const { data } = await api.delete(`${endpoint}/${id}`);
      return data;
    },
    onSuccess: () => {
      // ✅ Invalida a query específica
      if (queryKeyToInvalidate && queryKeyToInvalidate.length > 0) {
        queryClient.invalidateQueries({
          queryKey: queryKeyToInvalidate,
          exact: false,
        });
      }
    },
    onError: (error: any) => {
      const fallbackMessage = 'Erro ao excluir.';
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallbackMessage;

      showError(message);
    },
  });
};